import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "xpage-top-details-status-container" }
const _hoisted_2 = { class: "xpage-top-details-status" }
const _hoisted_3 = {
  key: 0,
  class: "icon-up-open-big"
}
const _hoisted_4 = {
  key: 1,
  class: "icon-down-open-big"
}
const _hoisted_5 = {
  key: 0,
  class: "xheader-search-dropdown"
}
const _hoisted_6 = { class: "application-st" }
const _hoisted_7 = ["disabled", "checked", "onInput"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "xdropdown-buttons" }
const _hoisted_11 = {
  key: 1,
  class: "denial-reason-box"
}
const _hoisted_12 = { class: "grid-container" }
const _hoisted_13 = { class: "column denial-reasons-column" }
const _hoisted_14 = { class: "new-denial-reason-entry" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "add-clear-buttons" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "max-reasons-message"
}
const _hoisted_20 = { class: "column requested-for-column" }
const _hoisted_21 = { class: "applicant-labels-row" }
const _hoisted_22 = { class: "label-semi-bold" }
const _hoisted_23 = { class: "checkbox-container" }
const _hoisted_24 = ["value", "checked", "onChange", "disabled"]
const _hoisted_25 = { class: "added-denial-reasons-container" }
const _hoisted_26 = {
  key: 0,
  class: "added-denial-reasons"
}
const _hoisted_27 = { class: "reason-content" }
const _hoisted_28 = { class: "reason-number" }
const _hoisted_29 = { class: "reason-description" }
const _hoisted_30 = { class: "reason-applicants" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "xdropdown-buttons" }

import {
  computed,
  ref,
  reactive,
  onBeforeMount,
  watch,
  onMounted,
  nextTick,
  toRefs,
} from "vue";
import { FormSchema, FieldSchema } from "@/models/form";
import { $api } from "@/services/api1";
import { JudgmentalDenial } from "@/models/opal";
import { useApplicationStore } from "@/store/store/applicationVMStore";
import {
  ApplicationStatusIds,
  JudgmentDenialTypeIds,
} from "@/types/application";
import { storeToRefs } from "pinia";
import { Type, LOSType, ProductIds } from "@/types/types";
import { useTypeStore } from "@/store/store/typeStore";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import functions from "@/use/functions";
import useFunctions from "@/use/functions1";
import useValidation from "@/use/validation";
import BaseFormField from "@/components/form-fields/BaseFormField.vue";
import { usePermissionsStore } from "@/store/store/permissionsStore";
import { Role, Roles } from "@/models/permissions";
import CancellationReasonForm from "@/components/v2/application/application-status-form/CancellationReasonForm.vue";
import { useApplicationStatusForm } from "@/composables/application/application-status/useApplicationStatusForm";

interface DenialReasonEntry {
  reasonId: number;
  applicants: number[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationStatus',
  setup(__props) {

const { decodeHTMLEncodedStr } = useFunctions();
const { validate } = useValidation();

const store = useStore();
const route = useRoute();
const applicationStore = useApplicationStore();
const permissionsStore = usePermissionsStore();
const typeStore = useTypeStore();
const { viewModel } = storeToRefs(applicationStore);

const cancellationReasonFormRef = ref<InstanceType<
  typeof CancellationReasonForm
> | null>(null);

// State
let checkboxFieldsSchema = reactive({} as FormSchema);
let denialReasons = reactive({} as any);
let selectedDenialReasons = ref([] as any[]);
let selectedDenialReasonIds = ref([] as number[]);
let reasonIds = ref([] as number[]);

const applicationJudgmentDenials = ref<JudgmentalDenial[]>([]);
const denialReasonEntries = ref<DenialReasonEntry[]>([]);
const selectedReason = ref<number | null>(null);

const previouslySelectedReasonIds = ref<number[]>([]);
const previouslySelectedReasons = ref<string[]>([]);
const showDenialReasonSection = ref<boolean>(false);
const showDenialReasonDropdown = ref<boolean>(false);
const showStatusDropdown = ref<boolean>(false);

const jdts = ref([] as LOSType[]);

const info = reactive({} as any);

const schema = reactive<FormSchema>({
  statusComment: {
    name: "statusComment",
    type: "textarea",
    hideLabel: true,
    required: true,
    errors: [],
    valid: true,
    maxLength: undefined,
    errorMessage: "Reason for change is required.",
  } as FieldSchema,
  otherDenialReason: {
    name: "otherDenialReason",
    type: "textarea",
    hideLabel: true,
    required: false,
    errors: [],
    valid: true,
    maxLength: 128,
    errorMessage: "Other reason is required.",
  } as FieldSchema,
});

const isAdmin = computed<boolean>(
  () =>
    permissionsStore.currentUser.roles?.find(
      (r: Role) => r.id === Roles.Admin,
    ) !== undefined,
);

const applicationId = computed<number>(() => applicationStore.viewModel?.id);

const statusName = computed<string>(
  () => applicationStore.viewModel?.statusName || "",
);

const isLegalPacketSigned = computed<boolean>(
  () => applicationStore.viewModel.isLegalPacketSigned,
);

const statusReasonId = computed(
  () => applicationStore.viewModel.statusReasonId,
);

const isPEL = computed<boolean>(
  () => applicationStore.viewModel.productTypeId === ProductIds.PEL,
);

const isRefiOrPEL = computed(
  () =>
    applicationStore.viewModel.productTypeId === ProductIds.PEL ||
    applicationStore.viewModel.productTypeId === ProductIds.REFI,
);

const applicants = computed(() => applicationStore.Applicants);

const showDenialReasonForm = computed(
  () =>
    showStatusDropdown.value &&
    info.newApplicationStatusId === ApplicationStatusIds.DECLINED,
);

const otherDenialReasonSelected = computed(() =>
  denialReasonEntries.value.some(
    (entry) => entry.reasonId === JudgmentDenialTypeIds.Other,
  ),
);

const totalDenialReasons = computed(() => denialReasonEntries.value.length);

const applicationStatuses = computed<Array<LOSType>>(() =>
  applicationStore.summary.applicationStatuses.filter(
    (s: LOSType) => s.visible === true,
  ),
);

const everHadRightToCancel = computed<boolean>(
  () => applicationStore.summary.everHadRightToCancel,
);

const currentApplicationStatusId = computed<number>(
  () => applicationStore.summary.statusId,
);

const version = ref<number>(2);

const {
  showCancellationReasonForm,
  updateApplicationStatusAsync,
  closeCancellationReasonForm,
} = useApplicationStatusForm({
  info: info,
  version: version,
  applicationId: applicationId,
  cancellationReasonFormRef,
  currentApplicationStatusId,
  onApplicationStatusUpdateSuccess: async () => {
    const referenceId =
      applicationStore.referenceId || route.params.referenceId.toString();

    await Promise.all([
      applicationStore.getApplication(referenceId),
      applicationStore.getApplicationSummary(referenceId),
      applicationStore.getApplicationComments(referenceId),
    ]);
  },
});

const getDenialReasonName = (id: number) => {
  return jdts.value.find((jdt) => jdt.id === id)?.description;
};

async function getDenialReasons() {
  if (currentApplicationStatusId.value === ApplicationStatusIds.DECLINED) {
    let alreadySelectedDenialReasons =
      await $api.applications.getApplicationJudgementDenials(
        applicationStore.applicationId,
      );

    if (
      alreadySelectedDenialReasons &&
      alreadySelectedDenialReasons?.judgmentDenialTypes?.length > 0
    ) {
      showDenialReasonDropdown.value = true;
      applicationJudgmentDenials.value =
        alreadySelectedDenialReasons?.judgmentDenialTypes;

      alreadySelectedDenialReasons?.judgmentDenialTypes?.forEach(
        (jdt: JudgmentalDenial) => {
          previouslySelectedReasons.value.push(jdt.judgmentDenialTypeName);
          previouslySelectedReasonIds.value.push(jdt.judgmentDenialTypeId);

          previouslySelectedReasons.value = [
            ...new Set(previouslySelectedReasons.value),
          ];
          previouslySelectedReasonIds.value = [
            ...new Set(previouslySelectedReasonIds.value),
          ];
        },
      );

      reasonIds.value = previouslySelectedReasonIds.value;
    }
  }
}

async function cancel() {
  showStatusDropdown.value = false;
  showDenialReasonSection.value = false;
  showDenialReasonDropdown.value = false;
  await resetDropdown();
  await nextTick();
}

function resetDropdown() {
  info.newApplicationStatusId = undefined;
  info.newStatusName = undefined;
  info.statusComment = undefined;
  resetDenialReasonsForm();
  resetDenialReasons();
  closeCancellationReasonForm();
  setApplicationStatus();
}

async function setApplicationStatus() {
  info.applicationStatusName = viewModel.value.statusName;

  if (info.applicationStatusName === "Declined") {
    showDenialReasonSection.value = true;
    showDenialReasonDropdown.value = true;
    await getDenialReasons();
  } else {
    resetDenialReasons();
    showDenialReasonSection.value = false;
    showDenialReasonDropdown.value = false;
  }
}

async function updateJudgmentalDenials() {
  const ApplicantJDTypeIds = denialReasonEntries.value
    .flatMap((entry) =>
      entry.applicants.map((applicantId) => ({
        applicantTypeId: applicants.value.find((a) => a.id === applicantId)
          ?.applicantTypeId,
        judgmentDenialTypeId: entry.reasonId,
      })),
    )
    .filter(
      (item) =>
        item.applicantTypeId !== undefined &&
        item.judgmentDenialTypeId !== null,
    );

  const applicationJudgementDenialRequest = {
    applicationId: applicationStore.applicationId,
    ApplicantJDTypeIds,
    otherJudgmentTypeReasonText: info?.otherDenialReason || "",
  };

  const response = await $api.applications.addOrUpdateJudgementDenials(
    applicationStore.applicationId,
    applicationJudgementDenialRequest,
  );

  if (response.errors || !response.applicationId) {
    functions.openModal({
      title: "Error",
      description: "There was an issue updating the Application Status",
      buttons: [
        {
          title: "Close",
          onClick: async () => {
            functions.closeModal();
            await resetDropdown();
          },
        },
      ],
    });
    console.log(`Error: updateJudgmentalDenials()`, response.errors);
    return false;
  } else {
    const referenceId = applicationStore.referenceId;
    await Promise.all([
      applicationStore.getApplication(referenceId),
      applicationStore.getApplicationSummary(referenceId),
      applicationStore.getApplicationComments(referenceId),
    ]);

    return true;
  }
}

async function saveStatusChange() {
  functions.setModalLoading();

  if (info.newApplicationStatusId === ApplicationStatusIds.DECLINED) {
    const applicantJDTypes = denialReasonEntries.value.flatMap((entry) =>
      entry.applicants.map((applicant) => ({
        applicantTypeId: applicants.value.find((a) => a.id === applicant)
          ?.applicantTypeId,
        judgmentDenialTypeId: entry.reasonId,
      })),
    );

    if (applicantJDTypes.length === 0) {
      functions.openModal({
        title: "Alert",
        description: "Please select at least one denial reason.",
      });
      return;
    }
  }

  let response = false;
  if (
    info.newApplicationStatusId &&
    currentApplicationStatusId.value !== info.newApplicationStatusId
  ) {
    response = await updateApplicationStatusAsync();
    if (!response) return;
  }
  if (info.newApplicationStatusId === ApplicationStatusIds.DECLINED) {
    response = await updateJudgmentalDenials();
  }
  if (response) {
    window.scrollTo(0, 0);
    functions.closeModal();
    showStatusDropdown.value = false;
    functions.setModalLoading(false);

    functions.openModal({
      title: "Success!",
      description: "The Application Status has been changed!",
      buttons: [
        {
          title: "Close",
          onClick: async () => {
            functions.closeModal();
            showStatusDropdown.value = false;
            info.statusComment = undefined;
            info.otherDenialReason = undefined;
            denialReasonEntries.value = [];
            showDenialReasonSection.value = false;
          },
        },
      ],
    });
  }
}

function removeReason(index: number) {
  denialReasonEntries.value.splice(index, 1);
}

function addAnotherReason() {
  if (totalDenialReasons.value >= 4) {
    functions.openModal({
      title: "Alert",
      description: "You have reached the maximum of 4 denial reasons.",
    });
    return;
  }
  selectedReason.value = null;
}

function resetDenialReasonsForm() {
  denialReasonEntries.value = [];
  selectedReason.value = null;

  info.otherDenialReason = undefined;
  info.statusComment = undefined;
  schema.statusComment.valid = true;
  schema.statusComment.errors = [];
  schema.otherDenialReason.valid = true;
  schema.otherDenialReason.required = false;
  schema.otherDenialReason.errors = [];
}

function dropdownClicked() {
  if (!applicationStore.summary.disabledStatuses) {
    showStatusDropdown.value = !showStatusDropdown.value;

    resetDenialReasons();
    resetDropdown();

    if (currentApplicationStatusId.value === ApplicationStatusIds.DECLINED) {
      showDenialReasonSection.value = true;
      showDenialReasonDropdown.value = true;
    } else {
      showDenialReasonSection.value = false;
      showDenialReasonDropdown.value = false;
    }
  }
}

function handleInput(event: LOSType) {
  info.newStatusName = event.name;
  info.newApplicationStatusId = event.id;

  const allowedStatuses = [
    ApplicationStatusIds.EVALUATION,
    ApplicationStatusIds.SUBMITTED_AND_PROCESSING,
  ];

  if (info.newApplicationStatusId === ApplicationStatusIds.DECLINED) {
    if (!allowedStatuses.includes(currentApplicationStatusId.value)) {
      functions.openModal({
        title: "Alert",
        description:
          "This status change is not allowed from the current application status",
        buttons: [
          {
            title: "Close",
            onClick: () => {
              functions.closeModal();
              closeDropdown();
              resetDropdown();
            },
          },
        ],
      });
    } else {
      resetDenialReasons();
      showDenialReasonSection.value = true;
      showDenialReasonDropdown.value = true;
    }
  } else if (info.newApplicationStatusId === ApplicationStatusIds.CANCELLED) {
    if (currentApplicationStatusId.value === ApplicationStatusIds.DECLINED) {
      cancellationReasonFormRef.value?.toggleForm(false);
      info.newStatusName = undefined;
      info.newApplicationStatusId = undefined;
      toggleAlertModal("This action is not allowed");
    } else {
      cancellationReasonFormRef.value?.toggleForm(true);
    }
  } else if (
    info.newApplicationStatusId === ApplicationStatusIds.SCHOOL_CERTIFICATION
  ) {
    const allowedStatus = [ApplicationStatusIds.SUBMITTED_AND_PROCESSING];

    if (
      !isAdmin.value ||
      !allowedStatus.includes(currentApplicationStatusId.value) ||
      !isLegalPacketSigned.value
    ) {
      toggleAlertModal("This action is not allowed");
    }
  } else if (
    // for Refi or PEL konly, when attempting to switch to Submit & Processing or Evaluation but was cancelled with a reason (RTC).
    isRefiOrPEL.value &&
    everHadRightToCancel.value &&
    currentApplicationStatusId.value === ApplicationStatusIds.CANCELLED &&
    statusReasonId.value !== null
  ) {
    toggleAlertModal(
      "This action cannot be taken. This application was cancelled by the applicant under the Right to Cancel.",
    );
  } else if (info.newApplicationStatusId === ApplicationStatusIds.COMPLETE) {
    if (isPEL.value && !isAdmin.value) {
      toggleAlertModal("This action is not allowed");
    }
  } else if (
    info.newApplicationStatusId ===
      ApplicationStatusIds.SUBMITTED_AND_PROCESSING ||
    info.newApplicationStatusId === ApplicationStatusIds.EVALUATION ||
    info.newApplicationStatusId === ApplicationStatusIds.NOT_SUBMITTED
  ) {
    if (
      currentApplicationStatusId.value ===
      ApplicationStatusIds.SCHOOL_CERTIFICATION
    ) {
      toggleAlertModal("This action is not allowed");
    }
  } else {
    resetDenialReasons();
    closeCancellationReasonForm();
    showDenialReasonSection.value = false;
    showDenialReasonDropdown.value = false;
    if (info.newApplicationStatusId === currentApplicationStatusId.value) {
      info.newStatusName = undefined;
      info.newApplicationStatusId = undefined;
    } else {
      return;
    }
  }
}

function toggleAlertModal(description: string) {
  functions.openModal({
    title: "Alert",
    description: description,
    buttons: [
      {
        title: "Close",
        onClick: () => {
          functions.closeModal();
          closeDropdown();
          resetDropdown();
        },
      },
    ],
  });
}

function closeDropdown() {
  showStatusDropdown.value = false;
}

function isApplicantSelectedForReason(applicantId: number): boolean {
  if (selectedReason.value == null) {
    return false;
  }
  return denialReasonEntries.value.some(
    (entry) =>
      entry.reasonId === selectedReason.value &&
      entry.applicants.includes(applicantId),
  );
}

function resetDenialReasons() {
  selectedDenialReasons.value = [];
  selectedDenialReasonIds.value = [];

  for (let [key, value] of Object.entries(denialReasons)) {
    denialReasons[key] = false;
  }
}

function getApplicantNames(applicantIds: number[]): string[] {
  return applicants.value
    .filter((applicant) => applicantIds.includes(applicant.id))
    .map((applicant) => applicant.applicantTypeName);
}

function confirmStatusChange() {
  const isDeclinedStatus =
    info.newApplicationStatusId === ApplicationStatusIds.DECLINED ||
    (info.newApplicationStatusId === currentApplicationStatusId.value &&
      currentApplicationStatusId.value === ApplicationStatusIds.DECLINED);

  const description =
    isDeclinedStatus && applicationJudgmentDenials.value.length === 0
      ? "Selected decline reasons will be used on AA Notices and CANNOT be changed once you proceed. Are you sure you want to change this status?"
      : "Are you sure you want to change this status?";

  functions.openModal({
    title: "Confirm",
    description: description,
    buttons: [
      {
        title: "Cancel",
        onClick: () => {
          cancellationReasonFormRef.value?.setSavingChanges(false);
          functions.closeModal();
        },
      },
      { title: "Save Changes", onClick: () => saveStatusChange() },
    ],
  });
}

function submit() {
  const isDeclinedStatus =
    info?.newApplicationStatusId === ApplicationStatusIds.DECLINED ||
    (info?.newStatusName === undefined &&
      currentApplicationStatusId.value === ApplicationStatusIds.DECLINED);

  const cleanedComment = info?.statusComment?.trim() || undefined;
  const cleanedOtherReason = info?.otherDenialReason?.trim() || undefined;
  info.statusComment = cleanedComment;
  info.otherDenialReason = cleanedOtherReason;

  if (isDeclinedStatus) {
    if (denialReasonEntries.value.length === 0) {
      functions.openModal({
        title: "Alert",
        description: "Please select at least one denial reason.",
      });
      return;
    }

    validate(schema.statusComment, info.statusComment);
    validate(schema.otherDenialReason, info.otherDenialReason);
  } else {
    if (
      (!info?.newApplicationStatusId && !info.statusComment) ||
      (info?.newApplicationStatusId === currentApplicationStatusId.value &&
        !info.statusComment)
    ) {
      functions.openModal({
        title: "Alert",
        description: "No changes were made. Do you want to make changes?",
        buttons: [
          {
            title: "Yes",
            onClick: async () => functions.closeModal(),
          },
          {
            title: "No",
            onClick: async () => {
              functions.closeModal();
              showStatusDropdown.value = false;
              await resetDropdown();
            },
          },
        ],
      });
      return;
    }

    if (cleanedComment && cleanedComment.length < 5) {
      functions.openModal({
        title: "Alert",
        description:
          "A comment of at least 5 characters is required to change the status!",
      });
      return;
    }
  }

  if (schema.statusComment.valid && schema.otherDenialReason.valid) {
    confirmStatusChange();
  }
}

function toggleApplicantForReason(applicantId: number, event: Event) {
  if (!selectedReason.value) {
    functions.openModal({
      title: "Alert",
      description: "Please select a denial reason first.",
    });
    (event.target as HTMLInputElement).checked = false;
    return;
  }

  const isChecked = (event.target as HTMLInputElement).checked;

  const existingEntryIndex = denialReasonEntries.value.findIndex(
    (entry) => entry.reasonId === selectedReason.value,
  );

  if (isChecked) {
    const existingEntry = denialReasonEntries.value.some(
      (entry) =>
        entry.reasonId === selectedReason.value &&
        entry.applicants.includes(applicantId),
    );

    if (!existingEntry) {
      denialReasonEntries.value.push({
        reasonId: selectedReason.value as number,
        applicants: [applicantId],
      });
    } else {
      const entryIndex = denialReasonEntries.value.findIndex(
        (entry) =>
          entry.reasonId === selectedReason.value &&
          entry.applicants.includes(applicantId),
      );
      if (entryIndex !== -1) {
        const entry = denialReasonEntries.value[entryIndex];
        entry.applicants = entry.applicants.filter((id) => id !== applicantId);

        if (entry.applicants.length === 0) {
          denialReasonEntries.value.splice(entryIndex, 1);
        }
      }
    }

    if (totalDenialReasons.value > 4) {
      functions.openModal({
        title: "Alert",
        description: "You have reached the maximum of 4 denial reasons.",
      });
    }
  }
}

watch(
  denialReasonEntries,
  (newEntries) => {
    reasonIds.value = newEntries
      .map((entry) => entry.reasonId)
      .filter((id): id is number => id !== null);
  },
  { immediate: true },
);

watch(showDenialReasonForm, (value) => {
  if (value) {
    closeCancellationReasonForm();
    resetDenialReasonsForm();
  }
});

watch(otherDenialReasonSelected, (value) => {
  if (value) {
    schema.otherDenialReason.required = true;
  } else {
    schema.otherDenialReason.required = false;
  }
});

onBeforeMount(() => {
  if (typeStore.getTypes(Type.JudgmentDenials)) {
    typeStore.getTypes(Type.JudgmentDenials).forEach((jdt: any) => {
      checkboxFieldsSchema[jdt.name] = {
        type: "checkbox",
        name: jdt.name,
        label: jdt.description,
        required: false,
        hideLabel: true,
      };
    });
  }
});

onMounted(() => {
  const denialTypes = typeStore.getTypes(Type.JudgmentDenials);
  if (denialTypes) {
    jdts.value = denialTypes.sort((a, b) => {
      const isAOther = a.description?.toLowerCase().includes("other");
      const isBOther = b.description?.toLowerCase().includes("other");
      if (isAOther && !isBOther) return 1;
      if (isBOther && !isAOther) return -1;
      return (a.description ?? "").localeCompare(b.description ?? "");
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", { onClick: dropdownClicked }, [
        _createTextVNode(_toDisplayString(statusName.value) + " ", 1),
        (showStatusDropdown.value)
          ? (_openBlock(), _createElementBlock("i", _hoisted_3))
          : (_openBlock(), _createElementBlock("i", _hoisted_4))
      ]),
      (showStatusDropdown.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("form", {
                onSubmit: _withModifiers(submit, ["prevent"]),
                autocomplete: "off"
              }, [
                _createElementVNode("nav", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applicationStatuses.value, (status) => {
                    return (_openBlock(), _createElementBlock("label", {
                      class: "xradio label-text",
                      key: status.name
                    }, [
                      _createTextVNode(_toDisplayString(status.name) + " ", 1),
                      _createElementVNode("input", {
                        type: "radio",
                        disabled: status.disabled,
                        name: "radio-status",
                        checked: status.selected,
                        onInput: ($event: any) => (handleInput(status))
                      }, null, 40, _hoisted_7),
                      _cache[4] || (_cache[4] = _createElementVNode("span", null, null, -1))
                    ]))
                  }), 128)),
                  (
                  info.newApplicationStatusId !==
                    _unref(ApplicationStatusIds).DECLINED &&
                  info.newApplicationStatusId !== _unref(ApplicationStatusIds).CANCELLED
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("p", null, [
                          _createTextVNode(" All open stipulations will be cancelled"),
                          _createElementVNode("br"),
                          _createTextVNode("upon completion of this status change. ")
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createVNode(CancellationReasonForm, {
                    ref_key: "cancellationReasonFormRef",
                    ref: cancellationReasonFormRef,
                    statusId: info.newApplicationStatusId,
                    initialStatusId: currentApplicationStatusId.value,
                    onSubmit: submit,
                    onCancel: cancel
                  }, null, 8, ["statusId", "initialStatusId"]), [
                    [_vShow, _unref(showCancellationReasonForm)]
                  ]),
                  (
                  info.newApplicationStatusId !==
                    _unref(ApplicationStatusIds).DECLINED &&
                  info.newApplicationStatusId !== _unref(ApplicationStatusIds).CANCELLED
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _cache[6] || (_cache[6] = _createElementVNode("h3", {
                          class: "smallcapitals",
                          style: {"padding-top":"10px"}
                        }, " Reason For Change: ", -1)),
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((info.statusComment) = $event)),
                            class: "reason-input"
                          }, "                  ", 512), [
                            [_vModelText, info.statusComment]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("button", {
                            onClick: _withModifiers(cancel, ["prevent"])
                          }, "Cancel"),
                          _createElementVNode("button", {
                            onClick: _withModifiers(submit, ["prevent"])
                          }, "Save Changes")
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 32)
            ])
          ]))
        : _createCommentVNode("", true),
      (showDenialReasonForm.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label-head" }, [
                  _createTextVNode("Denial Reason(s)"),
                  _createElementVNode("i", { style: {"color":"crimson"} }, "*")
                ], -1)),
                _cache[10] || (_cache[10] = _createElementVNode("p", null, "Please select a reason for the denial from the list below.", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label-semi-bold" }, "Denial Reason List:", -1)),
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedReason).value = $event)),
                    disabled: totalDenialReasons.value >= 4
                  }, [
                    _cache[7] || (_cache[7] = _createElementVNode("option", {
                      value: null,
                      disabled: ""
                    }, "Not Selected", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jdts.value, (jdt) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: jdt.id,
                        value: jdt.id
                      }, _toDisplayString(jdt.description), 9, _hoisted_16))
                    }), 128))
                  ], 8, _hoisted_15), [
                    [_vModelSelect, selectedReason.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    onClick: _withModifiers(addAnotherReason, ["prevent"]),
                    disabled: totalDenialReasons.value >= 4,
                    class: "add-btn"
                  }, " + Add Another Reason ", 8, _hoisted_18)
                ]),
                (totalDenialReasons.value >= 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("p", null, "You have reached the maximum of 4 denial reasons.", -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "label-head" }, [
                  _createTextVNode("Requested For"),
                  _createElementVNode("i", { style: {"color":"crimson"} }, "*")
                ], -1)),
                _cache[13] || (_cache[13] = _createElementVNode("p", null, "Select at least one applicant to apply the denial reason(s).", -1)),
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applicants.value, (applicant) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "applicant-column",
                      key: applicant.id
                    }, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(applicant.applicantTypeName), 1),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          value: applicant.id,
                          checked: isApplicantSelectedForReason(applicant.id),
                          onChange: ($event: any) => (toggleApplicantForReason(applicant.id, $event)),
                          disabled: !selectedReason.value
                        }, null, 40, _hoisted_24)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_25, [
                (denialReasonEntries.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(denialReasonEntries.value, (entry, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: index,
                            class: "added-denial-reason"
                          }, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("span", _hoisted_28, _toDisplayString(index + 1) + ".", 1),
                              _createElementVNode("span", _hoisted_29, _toDisplayString(entry.reasonId !== null
                        ? getDenialReasonName(entry.reasonId)
                        : "Unknown"), 1),
                              _createElementVNode("span", _hoisted_30, [
                                _cache[14] || (_cache[14] = _createTextVNode(" - Applicant: ", -1)),
                                _createElementVNode("span", null, _toDisplayString(getApplicantNames(entry.applicants).join(", ")), 1)
                              ])
                            ]),
                            _createElementVNode("button", {
                              onClick: _withModifiers(($event: any) => (removeReason(index)), ["prevent"]),
                              class: "remove-reason"
                            }, " X ", 8, _hoisted_31)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("h3", {
                class: "smallcapitals",
                style: {"padding-top":"10px"}
              }, [
                _createTextVNode(" Reason For Change:"),
                _createElementVNode("i", { style: {"color":"crimson"} }, "*")
              ], -1)),
              _createElementVNode("div", null, [
                _createVNode(BaseFormField, {
                  class: "reason-input",
                  modelValue: info.statusComment,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((info.statusComment) = $event)),
                  schema: schema.statusComment
                }, null, 8, ["modelValue", "schema"])
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "smallcapitals" }, [
                  _createTextVNode(" Other Reason:"),
                  _createElementVNode("i", { style: {"color":"crimson"} }, "*")
                ], -1)),
                _createVNode(BaseFormField, {
                  class: "reason-input",
                  modelValue: info.otherDenialReason,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((info.otherDenialReason) = $event)),
                  schema: schema.otherDenialReason
                }, null, 8, ["modelValue", "schema"])
              ], 512), [
                [_vShow, otherDenialReasonSelected.value]
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("button", {
                  onClick: _withModifiers(cancel, ["prevent"])
                }, "Cancel"),
                _createElementVNode("button", {
                  onClick: _withModifiers(submit, ["prevent"])
                }, "Save Changes")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ])), [
    [_directive_auto_animate, _ctx.$animate]
  ])
}
}

})